<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<b-row class="justify-content-center">
				<b-col md="8">
					<b-card-group>
						<b-card no-body class="p-4">
							<b-card-body>
								<form @submit.prevent="onSubmit">
									<h1>Prijava</h1>
									<p class="text-muted">Prijavite se z uporabniškim računom</p>
									<b-input-group class="mb-3">
										<b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
										<input v-model="email" type="email" class="form-control" placeholder="Uporabniško ime" required />
									</b-input-group>
									<b-input-group class="mb-4">
										<b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
										<input v-model="password" type="password" class="form-control" placeholder="Geslo" required />
									</b-input-group>
									<b-row>
										<b-col cols="6">
											<b-button type="submit" variant="primary" class="px-4" :disabled="loading">Prijava</b-button>
										</b-col>
										<b-col cols="6" class="text-right">
											<b-button variant="link" class="px-0">Ste pozabili geslo?</b-button>
										</b-col>
									</b-row>
									<app-mbox v-if="error" :text="error.message" @dismissed="onDismissed"></app-mbox>
								</form>
							</b-card-body>
						</b-card>
						<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
							<b-card-body class="text-center">
								<div>
									<h2>Težave s prijavo?</h2>
									<p>V sistem se lahko prijavite samo z že obstoječim uporabniškim imenom in geslom. Če imate pri prijavi težave, nas lahko preko spodnjega obrazca kontaktirate.</p>
									<b-button variant="primary" class="active mt-3">Pomoč</b-button>
								</div>
							</b-card-body>
						</b-card>
					</b-card-group>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase';
import service from '@/service';
import axios from 'axios';

export default {
	name: 'Login',
	data () {
		return {
			email: '',
			password: ''
		}
	},
	computed: {
		error () {
			return this.$store.getters.error;
		},
		loading () {
			return this.$store.getters.loading;
		}
	},
	methods: {
		onSubmit: function (event) {
			this.$store.dispatch('startLoading');
			this.$store.dispatch('clearError');
			firebase.auth().signInWithEmailAndPassword(this.email, this.password)
				.then(fbUser => {
					let loginUser = {
						id: fbUser.uid,
						display_name: fbUser.displayName,
						email: fbUser.email,
						phoneNumber: fbUser.phoneNumber,
						photoURL: fbUser.photoURL,
						creationTime: fbUser.metadata.creationTime,
						lastSignInTime: fbUser.metadata.lastSignInTime
					};
					fbUser.getIdToken().then(idToken => {
						this.$store.dispatch('setToken', idToken);
						axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`;
						// get database object
						service.getUser(loginUser)
							.then(response => {
								loginUser.dbid = response.data.id;
								loginUser.first_name = response.data.first_name;
								loginUser.last_name = response.data.last_name;
								loginUser.role = response.data.role;
								// store user
								this.$store.dispatch('setUser', loginUser);
								this.$router.replace('/');
							}).catch(error => {
								if (error) {
									this.$store.dispatch('setError', error);
									this.$store.dispatch('stopLoading');
								}
							});
					}).catch(function (error) {
						if (error) {
							this.$store.dispatch('setError', error);
							this.$store.dispatch('stopLoading');
						}
					});
				})
				.catch(error => {
					if (error) {
						this.$store.dispatch('setError', error);
						this.$store.dispatch('stopLoading');
					}
				});
		},
		onDismissed: function (event) {
			this.$store.dispatch('clearError');
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue